var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTurnaround(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M7.69342 6.86124C7.18094 6.86124 6.76549 6.44579 6.76549 5.9333C6.76549 5.42082 7.18094 5.00537 7.69342 5.00537L15.1169 5.00537C17.1668 5.00537 18.8286 6.66717 18.8286 8.7171C18.8286 10.767 17.1668 12.4288 15.1169 12.4288H7.69342C6.66845 12.4288 5.83755 13.2597 5.83755 14.2847C5.83755 15.3097 6.66845 16.1406 7.69342 16.1406H16.0448C16.5573 16.1406 16.9727 16.556 16.9727 17.0685C16.9727 17.581 16.5573 17.9964 16.0448 17.9964H7.69342C5.64349 17.9964 3.98169 16.3346 3.98169 14.2847C3.98169 12.2348 5.64349 10.573 7.69342 10.573H15.1169C16.1418 10.573 16.9727 9.74207 16.9727 8.7171C16.9727 7.69214 16.1418 6.86124 15.1169 6.86124H7.69342Z",
    fill: "#B0B7C3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.27753 8.06082C9.63991 8.4232 9.63991 9.01073 9.27753 9.37311C8.91515 9.73549 8.32762 9.73549 7.96524 9.37311L5.18144 6.58931C4.81906 6.22693 4.81906 5.6394 5.18144 5.27702L7.96524 2.49322C8.32762 2.13084 8.91515 2.13084 9.27753 2.49322C9.63991 2.8556 9.63991 3.44314 9.27753 3.80552L7.14988 5.93317L9.27753 8.06082Z",
    fill: "#B0B7C3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5335 19.1961C13.1711 19.5584 13.1711 20.146 13.5335 20.5084C13.8959 20.8707 14.4834 20.8707 14.8458 20.5084L17.6296 17.7246C17.992 17.3622 17.992 16.7747 17.6296 16.4123L14.8458 13.6285C14.4834 13.2661 13.8959 13.2661 13.5335 13.6285C13.1711 13.9909 13.1711 14.5784 13.5335 14.9408L15.6612 17.0684L13.5335 19.1961Z",
    fill: "#B0B7C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurnaround);
export default __webpack_public_path__ + "static/media/turnaround.7a86610271a11d071371498d7a173871.svg";
export { ForwardRef as ReactComponent };